<template>
    <div class="backoffice-members">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Member List" }}</h2>
            </div>
            <div class="right" v-show="$page.props.p['members.manage']">
                <!-- <v-btn color="regular"
                @click="bulkModal = true"
                v-if="$vuetify.breakpoint.mdAndUp">
                    <v-icon small class="mr-2">mdi-account-arrow-left-outline</v-icon>
                    {{ $page.props.lang.bulkUpload || "Bulk upload" }}
                </v-btn> -->
                <NewMemberDialog :lang="lang" :country_code="country_code"></NewMemberDialog>

            </div>
        </div>
        <div class="filter-section" style="margin-bottom:20px;">
            <v-row>
                <v-col cols="12" sm="6" md="3"  class="pb-0">
                    <v-text-field v-model="form.search" :label="$page.props.lang.filter_search || 'Search'"
                    background-color="#FFFFFF" outlined hide-details dense prepend-inner-icon="mdi-magnify" class="table-search"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="3"  class="pb-0">
                    <v-select v-model="form.status" :items="statuses" hide-details label="Status"
                    outlined dense background-color="#FFFFFF"></v-select>
                </v-col>
                <v-col  cols="6" sm="6" md="3"  class="pb-0">
                    <v-select v-model="form.mem_status" hide-details :items="mem_statuses" :label="$page.props.lang.mem_status || 'Membership Status'"
                    outlined dense background-color="#FFFFFF"></v-select>
                </v-col>
                <v-col cols="6" sm="6" md="3"  class="pb-0">
                    <v-select v-model="form.gender" hide-details :items="genders" :label="$page.props.lang.gender || 'Gender'"
                    outlined dense background-color="#FFFFFF"></v-select>
                </v-col>
                 <v-col cols="6" sm="6" md="3"  class="pb-0">
                    <v-select v-model="form.subscription" item-text="name" item-value="id" hide-details :items="subscriptions" :label="$page.props.lang.by_membership || 'By Membership'"
                    outlined dense background-color="#FFFFFF" clearable></v-select>
                </v-col>
                 <v-col cols="6" sm="6" md="3"  class="pb-0">
                    <v-select v-model="form.absence" hide-details :items="absence_statuses" :label="$page.props.lang.by_absence || 'Absence status'"
                    outlined dense background-color="#FFFFFF" clearable></v-select>
                </v-col>
                <v-col cols="6" sm="6" md="3" class="pb-0">
                    <v-checkbox dense class="float-left shrink mr-4 mt-0" v-model="form.birthday" :label="$page.props.lang.birthday || 'Birthday soon'"></v-checkbox>
                    <v-checkbox dense class="float-left shrink mr-0 mt-0" v-model="form.with_depth" :label="$page.props.lang.with_depth || 'Show debtholders'"></v-checkbox>
                </v-col>
            </v-row>
        </div>

        <v-row style="margin-bottom:5px;">
            <v-col cols="6" class="pt-6">
            </v-col>

            <v-col cols="6" class="text-right">
                <v-tooltip bottom open-delay="400">
                    <template v-slot:activator="{on, attrs}">
                        <v-btn @click="exportMembers" color="primary" class="mr-2" fab x-small outlined v-bind="attrs" v-on="on">
                            <v-icon>mdi-file-excel-box</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $page.props.lang.export || 'Export' }}</span>
                </v-tooltip>
                <v-btn color="primary" @click="smsModal = true" :disabled="isDisabled">
                    <v-icon v-if="$vuetify.breakpoint.mdAndUp" small style="margin-top: 0.5px;">mdi-plus</v-icon>
                    <v-icon v-else small style="margin-top: 0.5px;">mdi-message-outline</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp && use_mobile_app == 1" class="ml-2">{{ $page.props.lang.message ||  "Message" }}</span>
                    <span v-if="$vuetify.breakpoint.mdAndUp && use_mobile_app == 0" class="ml-2">SMS</span>
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="bulkModal" max-width="500px" content-class="bulk">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.bulkUpload || "Bulk upload" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="bulkModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <div class="fields">
                            <p class="message">{{ $page.props.lang.pleaseDontChange || "Please don’t change file format and don’t rename the file" }}</p>
                            <a href="/backoffice/members/downloadMembersCsvTemplate">
                                <v-btn :disabled="uploading" color="regular"><v-icon small class="mr-2">mdi-download</v-icon>{{ $page.props.lang.downloadTemplate || "Download Template" }}</v-btn>
                            </a>
                            <v-btn color="success" @click="$refs.inputUpload.click()" :loading="uploading"><v-icon small class="mr-2">mdi-upload</v-icon>{{ $page.props.lang.upload || "Upload" }}</v-btn>
                            <input v-show="false" ref="inputUpload" type="file" @change="onFileChange">
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>


        <SmsModalMembers
        v-if="smsModal"
        :open="smsModal"
        :sms_credit="sms_credit"
        :use_mobile_app="use_mobile_app"
        :recipients="selectedMembersComputed"
        @close="smsModal = false">
        </SmsModalMembers>

        <div class="table-container">
            <v-data-table
            v-model="selectedMembers"
            :headers="computedHeaders"
            :items="members.data"
            :server-items-length="members.total"
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
            item-key="id"
            show-select
            checkbox-color="primary"
            :page="members.current_page"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            mobile-breakpoint="0"
            :footer-props="{
                    'items-per-page-options': [5, 10, 25, 50]
                }"
            >
                <template v-slot:item.first_name="{ item }">
                    <inertia-link :href="'/backoffice/members/details/'+item.id +'/overview'" class="name">
                        <v-avatar size="40">
                            <img :src="item.profile_photo_url + '?w=80'" alt="">
                        </v-avatar>
                        {{ item.first_name }} {{ item.last_name }}
                    </inertia-link>
                </template>
                <template v-slot:item.gender="{ item }">
                    {{ gender(item.gender) }}
                </template>
                <template v-slot:item.birth_date="{ item }">
                    {{ item.birth_date | formatDate}}
                </template>
                <template v-slot:item.phone_number="{ item }">
                    {{ item.phone_number }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon v-if="item.notes_count" @click="$inertia.visit('/backoffice/members/details/'+item.id+'/notes')">
                        <v-badge dot>
                            <v-icon>mdi-note</v-icon>
                        </v-badge>
                    </v-btn>
                    <v-btn @click="remove(item)"  color="red" :id="'delete' + item.id" v-show="$page.props.p['members.remove']" icon>
                        <v-icon>mdi-delete</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.deletePayment || "Delete"}}</span>
                        </v-tooltip>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
        <v-snackbars :objects.sync="messageObjects" top right>
            <template v-slot:action="{ close }">
                <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbars>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import Pagination from '@/js/Components/Pagination'
import throttle from 'lodash/throttle'
import SmsModalMembers from './Components/SmsModalMembers'
import NewMemberDialog from './Components/NewMemberDialog'
import pickBy from 'lodash/pickBy'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title: this.$page.props.lang.title || "List of Members"
        }
    },
    layout: AppLayout,
    components: {
        Pagination,
        SmsModalMembers,
        NewMemberDialog
    },
    props: {
        members: Object,
        filters: Object,
        lang: Object,
        country_code: String,
        sms_credit: Number,
        subscriptions: Array,
        use_mobile_app: Number
    },
    remember: {
        data: ['sortDesc']
    },
    data(){
        return {
            form: {
                search: this.filters.search,
                status: this.filters.status,
                mem_status: this.filters.mem_status,
                gender: this.filters.gender,
                birthday: this.filters.birthday,
                with_depth: this.filters.with_depth,
                subscription: this.filters.subscription,
                absence: this.filters.absence
            },
            smsModal: false,
            saving: false,
            membersHeaders: [
                {text: this.lang.table_fullName || 'Full name', value: 'first_name', align: 'start'},
                {text: this.lang.table_birthDate || 'Birth date', value: 'birth_date'},
                {text: this.lang.table_gender || 'Gender', value: 'gender', sortable: false},
                {text: this.lang.table_email || 'Email', value: 'email', sortable: false},
                {text: this.lang.table_phone || 'Phone number', value: 'phone_number', sortable: false},
                {text: 'TOS', value: 'accepted_terms_at', sortable: false},
                {text: "", value: 'actions', sortable: false, align: 'end'}
            ],
            selectedMembers:[],
            totalMembers: this.members.total,

            memberModal: false,
            newMember: {
                first_name: '',
                last_name: '',
                birth_date: null,
                gender: '',
                email: '',
                phone_number: '',
                note: ''
            },
            resetMember: {
                first_name: '',
                last_name: '',
                birth_date: null,
                gender: '',
                email: '',
                phone_number: '',
                note: ''
            },
            messageObjects: [],
            responseErrors: {},
            resetErrors: {
                first_name: '',
                last_name: '',
                email: '',
                gender: '',
                birth_date: ''
            },
            bulkModal: false,
            templateUploadFile: '',
            uploading: false,
            options:{page:this.members.current_page, itemsPerPage:this.members.per_page},
            page: null,
            sortBy: [],
            sortDesc: [],
            search: null,
            statuses:[
                {'text': this.lang.all_members || 'All Members' , value: null},
                {'text': this.lang.all_active || "Only Active", value: "1"},
                {'text': this.lang.all_disabled || "Only Inactive", value: "-1" }
            ],
            mem_statuses:[
                {'text': this.lang.all_members || 'All Members', value: null},
                {'text': this.lang.no_active_mem || 'No active membership', value: 1},
                {'text': this.lang.exp_in_7 || 'Expires in 7 days', value: 2},
                {'text': this.lang.exp_in_14 || 'Expires in 14 days', value: 3}
            ],
            genders:[
                {'text': this.lang.all_members || 'All Members' , value: null},
                {'text': this.lang.male_filter || 'Male' , value: 'male'},
                {'text': this.lang.female_filter || 'Female' , value: 'female'},
                {'text': this.lang.other_filter || 'Other' , value: 'other'},

            ],
            absence_statuses:[
                {'text': this.lang.absence_7 || 'Absent last 7 days', value: "1"},
                {'text': this.lang.absence_14 || 'Absent last 14 days', value: "2"},
                {'text': this.lang.absence_30 || 'Absent last 30 days', value: "3"}
            ]
        }
    },
    computed: {
        formatDatePicker(){
            if(this.newMember.birth_date !== null){
                return moment(this.newMember.birth_date).format('D.M.Y.');
            }else{
                return null;
            }
        },

        userPermissions() {
            let userPerm = []
            userPerm = this.p.map(item => {
                let pair = {}
                pair[item.name]=item.value
                return pair
            })
            return Object.assign(...userPerm)
        },
        computedHeaders() {
            if (this.$vuetify.breakpoint.width > 599) {
                return this.membersHeaders
            } else {
                return this.membersHeaders.filter(item => item.value === 'first_name')
            }
        },

        isDisabled(){
            if(this.selectedMembers.length == 0){
                return true;
            }
        },

        selectedMembersComputed(){
           return this.selectedMembers.map(function(el){
                return {id: el.id, full_name: `${el.first_name} ${el.last_name}`, profile_photo_url: el.profile_photo_url};
            })
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get("/backoffice/members", pickBy(this.form), { preserveState: true })
            }, 250)

        },
        options:{

             handler (val, oldVal) {

                if(val.page != oldVal.page || val.sortBy != oldVal.sortBy || val.sortDesc != oldVal.sortDesc || val.itemsPerPage != oldVal.itemsPerPage){

                    let data = {}
                    let order = this.options.sortDesc[0]===false ? 'asc' : 'desc';

                    if (this.options.sortDesc.length>0 & oldVal.sortDesc != val.sortDesc) {
                        data.order = order
                        data.sort = this.options.sortBy[0]
                        data.page = oldVal.page

                    }else{
                        data.page = val.page;
                    }

                    let obj = this.form;

                    if (this.form.search!==null) { data.search = this.form.search}
                    data.items_per_page = this.options.itemsPerPage;

                    let finalData = Object.assign(data, obj);

                    this.$inertia.get('/backoffice/members', pickBy(finalData), {preserveState: true});
                    this.options.page = this.members.current_page;
                }

            },
            deep: true,
        },
        memberModal: function (value) {
            if (value===false) {
                this.newMember = Object.assign({}, this.resetMember)
                this.responseErrors = this.resetErrors
            }
        },


    },
    created() {
        this.initPageAndSort()
    },
    methods: {

        initPageAndSort() {
            let pageUrl = new URLSearchParams(window.location.search)
            let sortDesc = pageUrl.get('order')
            let sortBy = pageUrl.get('sort')
            let page = pageUrl.get('page')
            this.page = page ? page : null
            // this.page = this.members.current_page
            sortBy ? this.sortBy[0] = sortBy : ''
            if (sortDesc) {
                sortDesc==='asc' ? this.sortDesc[0] = false : this.sortDesc[0] = true
            }
        },

        exportMembers(){
            let queryString = window.location.search;
            window.location.href = '/backoffice/members/export' + queryString;
        },


        downloadTemplate() {
            axios.get('/backoffice//members/downloadMembersCsvTemplate')
                .then(response => {

                })
                .catch(error => {

                })
        },
        remove(member){

            let confirmMessage = this.$page.props.lang.confirm_remove || "Removing member, you will remove also his transactions, memberships and apointments. Are you sure?";
            let confirmed = confirm(confirmMessage);

            if(confirmed){
                this.$inertia.post('/backoffice/members/remove', {id: member.id},
                {
                    preserveState: true,
                    preserveScroll: true,
                    only: ['members']
                });
            }
        },
        async onFileChange(e) {
            this.uploading = true
            if(e.target.files[0]) {
                let file =  e.target.files[0]
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData()
                formData.append('file', file)
                await axios.post('/backoffice/members/uploadMembersCsv', formData, config)
                    .then(response => {
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    })
                    .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    })
                this.uploading = false
                this.bulkModal = false
            }
        },
        gender(gender){
            if(gender === 0) return this.$page.props.lang.male || 'Male';
            else if(gender === 1) return this.$page.props.lang.female || 'Female';
            else return this.$page.props.lang.other || 'Other';
        }
    }
}
</script>
